<script lang="ts">
  let open = false
  let xmrCopied = false
  let lnCopied = false
  let coffeeTooltip = false

  const XMR = "88yZhiMwHs8FLFZvd78AyRRqQ7kgF4BorXjX3vye8B1nVoMtP2AnNe32rgbsUP2NYPRmFc9vqUsi1ckKmoHX1YGXEezb3FE"
  const LN = "alestrex@cake.cash"
  const TROCADOR = `https://trocador.app/anonpay/?ticker_to=xmr&network_to=Mainnet&donation=true&address=${XMR}`
  const XMRCHAT = "https://xmrchat.com/alestre"

  function copyXmr() {
    navigator.clipboard.writeText(XMR)
    xmrCopied = true
    setTimeout(() => (xmrCopied = false), 2000)
  }

  function copyLn() {
    navigator.clipboard.writeText(LN)
    lnCopied = true
    setTimeout(() => (lnCopied = false), 2000)
  }

  function showCoffee() {
    coffeeTooltip = true
    setTimeout(() => (coffeeTooltip = false), 3000)
  }
</script>

{#if open}
  <div class="mx-4 mb-1 rounded-lg bg-tinted-600 p-3">
    <p class="mb-2 text-xs font-semibold text-neutral-300">Crypto and coffee accepted</p>
    <div class="flex flex-col gap-1.5">
      <button
        on:click={copyLn}
        class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors text-left">
        <i class="fa fa-bolt text-yellow-400 w-3" />
        {lnCopied ? "Copied!" : "Copy Lightning address"}
      </button>
      <button
        on:click={copyXmr}
        class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors text-left">
        <span class="w-3 text-center text-tinted-200 font-bold text-xs">Ɱ</span>
        {xmrCopied ? "Copied!" : "Copy XMR address"}
      </button>
      <a
        href={XMRCHAT}
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors">
        <i class="fa fa-comment-dollar w-3" />
        XMR via xmrchat
      </a>
      <a
        href={TROCADOR}
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors">
        <i class="fa fa-coins w-3" />
        Other cryptos
      </a>
      <div class="relative">
        <button
          on:click={showCoffee}
          class="flex w-full items-center gap-2 rounded px-3 py-1.5 text-xs text-neutral-200 bg-tinted-500 hover:bg-tinted-400 transition-colors text-left">
          <i class="fa fa-mug-hot w-3" />
          Buy me a coffee
        </button>
        {#if coffeeTooltip}
          <div class="absolute bottom-full left-0 mb-1 rounded bg-neutral-900 px-2 py-1 text-xs text-neutral-300 whitespace-nowrap shadow-lg border border-tinted-500">
            invite me in a private message
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<button
  on:click={() => (open = !open)}
  class="staatliches flex w-full items-center gap-3 px-6 py-2 text-sm text-tinted-400 hover:text-tinted-100 transition-colors">
  <i class="fa fa-heart" />
  Support this relay
  <i class="fa fa-chevron-{open ? 'up' : 'down'} ml-auto text-xs" />
</button>
